/**
 * Адрес страницы-приглашения отдельным модулем: его берёт и панель раздела, которая работает
 * в браузере. Через общий модуль виджета в браузерный пакет уехали бы серверные запросы страницы.
 */
export const joinPagePath = '/fulfillment/join'
